import React from 'react';
import styled from 'styled-components';

const ILGAN_MEANING = {
  '甲': '강한 성장 의지, 개척형',
  '乙': '유연한 적응력, 협력형',
  '丙': '밝은 이상, 표현·소통형',
  '丁': '섬세한 집중력, 장인형',
  '戊': '든든한 안정감, 중재형',
  '己': '실용적 판단, 내실형',
  '庚': '명확한 결단력, 실행형',
  '辛': '날카로운 분석, 완벽주의형',
  '壬': '넓은 안목, 전략가형',
  '癸': '깊은 통찰, 직관형',
};

const Wrap = styled.div`
  margin-top: 12px;
  padding: 12px 14px;
  background: #111827;
  border: 1px solid #4c1d95;
  border-radius: 10px;
`;

const IlganRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

const IlganChar = styled.div`
  font-size: 28px;
  font-weight: 900;
  color: #a78bfa;
  line-height: 1;
  min-width: 32px;
`;

const IlganInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const IlganLabel = styled.div`
  color: #6b7280;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const IlganMeaning = styled.div`
  color: #c4b5fd;
  font-size: 13px;
`;

const PillarRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

const Pillar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #1f2937;
  border: 1px solid #374151;
  border-radius: 8px;
  padding: 6px 10px;
  min-width: 48px;
`;

const PillarLabel = styled.div`
  color: #6b7280;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  margin-bottom: 3px;
`;

const PillarText = styled.div`
  color: #e5e5e5;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;

export default function SajuDisplay({ sajuStructured }) {
  if (!sajuStructured) return null;

  const { ilgan, year, month, day, hour } = sajuStructured;
  const pillars = [
    { label: '년주', value: year },
    { label: '월주', value: month },
    { label: '일주', value: day },
    hour ? { label: '시주', value: hour } : null,
  ].filter(Boolean);

  return (
    <Wrap>
      <IlganRow>
        <IlganChar>{ilgan}</IlganChar>
        <IlganInfo>
          <IlganLabel>일간 (日干)</IlganLabel>
          <IlganMeaning>{ILGAN_MEANING[ilgan] || ''}</IlganMeaning>
        </IlganInfo>
      </IlganRow>
      <PillarRow>
        {pillars.map(p => (
          <Pillar key={p.label}>
            <PillarLabel>{p.label}</PillarLabel>
            <PillarText>{p.value}</PillarText>
          </Pillar>
        ))}
      </PillarRow>
    </Wrap>
  );
}
